// CUSTOM ICONS WITH SIZES NOT PART OF ICONV2

import React from 'react';

import { publicaColors } from '~/src/dash/utils/colors';

interface IIconProps {
  color?: string;
}

export const AllowIconExtraLarge = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.5965 9.92334H11.8393V8.65627C11.8393 7.46731 10.8467 6.50012 9.6268 6.50012H8.71246C7.4924 6.50012 6.5 7.46728 6.5 8.65627V10.469H7.40821V8.65627C7.40821 7.95531 7.99312 7.38525 8.71236 7.38525H9.62671C10.3461 7.38525 10.9312 7.95531 10.9312 8.65627V10.0456C10.2136 10.3115 9.70135 10.9869 9.70135 11.7784V15.6455C9.70144 16.668 10.5552 17.5001 11.6045 17.5001H15.5969C16.6462 17.5001 17.5 16.6679 17.5 15.6453V11.7784C17.5 10.7557 16.6461 9.92348 15.5966 9.92348L15.5965 9.92334ZM16.5919 15.6453C16.5919 16.1801 16.1455 16.6151 15.5969 16.6151H11.6045C11.0558 16.6151 10.6095 16.18 10.6095 15.6453V11.7782C10.6095 11.2433 11.0559 10.8083 11.6045 10.8083H15.5964C16.1452 10.8083 16.5917 11.2433 16.5917 11.7782L16.5919 15.6453Z'
        fill={publicaColors.green}
      />
      <path
        d='M14.8158 13.626L13.2716 12.5808C13.1933 12.5278 13.1045 12.4999 13.0142 12.4999C12.9238 12.4999 12.835 12.5278 12.7567 12.5808C12.6785 12.6338 12.6135 12.71 12.5683 12.8018C12.5232 12.8936 12.4994 12.9977 12.4995 13.1037V14.8951C12.499 15.0013 12.5225 15.1057 12.5676 15.1977C12.6126 15.2898 12.6777 15.3662 12.7561 15.4193C12.8345 15.4724 12.9235 15.5002 13.014 15.4999C13.1046 15.4996 13.1934 15.4712 13.2716 15.4177L14.8158 14.3726C14.8716 14.3348 14.918 14.2804 14.9503 14.2149C14.9825 14.1494 14.9995 14.075 14.9995 13.9994C14.9995 13.9238 14.9825 13.8495 14.9503 13.784C14.918 13.7184 14.8716 13.664 14.8158 13.6262V13.626ZM13.051 14.9693C13.0398 14.9769 13.0271 14.9809 13.0142 14.9809C13.0013 14.9809 12.9886 14.9769 12.9774 14.9694C12.9663 14.9618 12.957 14.9509 12.9505 14.9378C12.9441 14.9247 12.9406 14.9099 12.9406 14.8947V13.1037C12.9404 13.0885 12.9437 13.0735 12.9501 13.0604C12.9566 13.0472 12.9661 13.0364 12.9774 13.0291C12.9887 13.0214 13.0015 13.0172 13.0145 13.0171C13.0273 13.0172 13.0399 13.0213 13.051 13.0289L14.4848 13.9995L13.051 14.9693Z'
        fill={publicaColors.green}
      />
      <path
        d='M12 2.5C6.76233 2.5 2.5 6.76233 2.5 12C2.5 17.2377 6.76233 21.5 12 21.5C17.2377 21.5 21.5 17.2377 21.5 12C21.5 6.76233 17.2377 2.5 12 2.5'
        stroke={publicaColors.green}
        stroke-width='1.5'
      />
    </svg>
  );
};

export const AllowIconHuge = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M29.733 19.9956H23.2842V17.8208C23.2842 15.7801 21.5806 14.1201 19.4868 14.1201H17.9175C15.8234 14.1201 14.1201 15.7801 14.1201 17.8208V20.9321H15.6789V17.8208C15.6789 16.6177 16.6828 15.6393 17.9173 15.6393H19.4867C20.7215 15.6393 21.7255 16.6177 21.7255 17.8208V20.2054C20.494 20.6618 19.6148 21.821 19.6148 23.1795V29.8168C19.6149 31.5718 21.0803 33 22.8812 33H29.7335C31.5346 33 33 31.5717 33 29.8165V23.1796C33 21.4243 31.5344 19.9958 29.7331 19.9958L29.733 19.9956ZM31.4414 29.8165C31.4414 30.7344 30.6753 31.4809 29.7336 31.4809H22.8813C21.9395 31.4809 21.1735 30.7342 21.1735 29.8165V23.1791C21.1735 22.2611 21.9397 21.5144 22.8813 21.5144H29.7328C30.6747 21.5144 31.4411 22.2611 31.4411 23.1791L31.4414 29.8165Z'
        fill={publicaColors.green}
      />
      <path
        d='M28.3935 26.3506L25.7432 24.5567C25.6088 24.4657 25.4564 24.4178 25.3013 24.4178C25.1461 24.4179 24.9937 24.4658 24.8594 24.5567C24.7251 24.6477 24.6136 24.7785 24.5361 24.9361C24.4586 25.0936 24.4179 25.2723 24.418 25.4542V28.529C24.4171 28.7111 24.4574 28.8903 24.5348 29.0483C24.6121 29.2063 24.7238 29.3375 24.8583 29.4286C24.9929 29.5197 25.1457 29.5674 25.3011 29.5669C25.4565 29.5664 25.609 29.5177 25.7432 29.4258L28.3935 27.6322C28.4894 27.5672 28.569 27.4738 28.6244 27.3614C28.6797 27.2489 28.7089 27.1214 28.7089 26.9916C28.7089 26.8618 28.6797 26.7342 28.6244 26.6218C28.569 26.5093 28.4894 26.4159 28.3935 26.351V26.3506ZM25.3644 28.6563C25.3453 28.6693 25.3235 28.6761 25.3014 28.6761C25.2792 28.6761 25.2574 28.6693 25.2383 28.6563C25.2191 28.6434 25.2031 28.6247 25.1921 28.6022C25.181 28.5798 25.1751 28.5543 25.1751 28.5283V25.4542C25.1747 25.4281 25.1803 25.4024 25.1914 25.3798C25.2025 25.3573 25.2187 25.3387 25.2382 25.3262C25.2576 25.3129 25.2795 25.3058 25.3019 25.3055C25.3239 25.3058 25.3455 25.3128 25.3644 25.3258L27.8254 26.9917L25.3644 28.6563Z'
        fill={publicaColors.green}
      />
      <path
        d='M24 5C13.5247 5 5 13.5247 5 24C5 34.4753 13.5247 43 24 43C34.4753 43 43 34.4753 43 24C43 13.5247 34.4753 5 24 5'
        stroke={publicaColors.green}
        stroke-width='3.5'
      />
    </svg>
  );
};

export const BlockIconExtraLarge = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M20 12C20 10.154 19.365 8.458 18.312 7.103L7.103 18.312C8.458 19.366 10.154 20 12 20C16.411 20 20 16.411 20 12ZM4 12C4 13.846 4.635 15.542 5.688 16.897L16.897 5.688C15.542 4.634 13.846 4 12 4C7.589 4 4 7.589 4 12ZM12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2Z'
        fill={publicaColors.red}
      />
    </svg>
  );
};

export const BlockIconHuge = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M40 24C40 20.308 38.73 16.916 36.624 14.206L14.206 36.624C16.916 38.732 20.308 40 24 40C32.822 40 40 32.822 40 24ZM8 24C8 27.692 9.27 31.084 11.376 33.794L33.794 11.376C31.084 9.268 27.692 8 24 8C15.178 8 8 15.178 8 24ZM24 4C35.028 4 44 12.972 44 24C44 35.028 35.028 44 24 44C12.972 44 4 35.028 4 24C4 12.972 12.972 4 24 4Z'
        fill={publicaColors.red}
      />
    </svg>
  );
};

export const CheckmarkIconExtraLarge = ({
  color = publicaColors.black,
}: IIconProps): JSX.Element => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.7046 8.3945L10.9206 13.3635L9.2876 11.2775C8.9476 10.8415 8.3176 10.7655 7.8836 11.1065C7.4486 11.4465 7.3716 12.0755 7.7126 12.5095L10.1436 15.6165C10.3336 15.8585 10.6236 15.9995 10.9316 15.9995H10.9386C11.2476 15.9985 11.5396 15.8525 11.7266 15.6055L16.2956 9.6055C16.6306 9.1655 16.5456 8.5395 16.1056 8.2045C15.6646 7.8695 15.0386 7.9555 14.7046 8.3945ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.477 2 2 6.478 2 12C2 17.522 6.477 22 12 22C17.523 22 22 17.522 22 12C22 6.478 17.523 2 12 2Z'
        fill={color}
      />
    </svg>
  );
};

export const CheckmarkIconHuge = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M29.4092 16.789L21.8412 26.727L18.5752 22.555C17.8952 21.683 16.6352 21.531 15.7672 22.213C14.8972 22.893 14.7432 24.151 15.4252 25.019L20.2872 31.233C20.6672 31.717 21.2472 31.999 21.8632 31.999H21.8772C22.4952 31.997 23.0792 31.705 23.4532 31.211L32.5912 19.211C33.2612 18.331 33.0912 17.079 32.2112 16.409C31.3292 15.739 30.0772 15.911 29.4092 16.789ZM24 40C15.178 40 8 32.822 8 24C8 15.178 15.178 8 24 8C32.822 8 40 15.178 40 24C40 32.822 32.822 40 24 40ZM24 4C12.954 4 4 12.956 4 24C4 35.044 12.954 44 24 44C35.046 44 44 35.044 44 24C44 12.956 35.046 4 24 4Z'
        fill={publicaColors.black}
      />
    </svg>
  );
};

export const UndoIconExtraLarge = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.1047 11.412C13.1675 11.412 15.0282 12.3731 16.2052 13.9172C15.6639 11.6414 13.5826 9.94141 11.1047 9.94141C10.7845 9.94141 10.5258 9.67848 10.5258 9.35319V8.22205L7.73291 10.6773L10.5258 13.1549V12.0002C10.5258 11.6749 10.7845 11.412 11.1047 11.412ZM16.7595 17C16.4926 17 16.2599 16.8147 16.1968 16.5512C15.6815 14.4048 13.8688 12.8542 11.6839 12.6195V13.2789C11.6839 13.6942 11.4413 14.0642 11.0511 14.2436C10.6279 14.4395 10.1341 14.3689 9.79074 14.0648L6.85779 11.4625C6.63026 11.2602 6.5 10.9737 6.5 10.6766C6.5 10.3796 6.63026 10.0931 6.85779 9.89079L9.79074 7.2885C10.1341 6.9844 10.6279 6.91381 11.0511 7.10969C11.4413 7.28909 11.6839 7.65908 11.6839 8.07436V8.79082C14.9399 9.08081 17.5 11.7943 17.5 15.0883C17.5 15.5647 17.4398 16.0565 17.3217 16.5506C17.2592 16.8147 17.027 17 16.7595 17Z'
        fill={publicaColors.black}
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2 12C2 6.478 6.477 2 12 2C17.523 2 22 6.478 22 12C22 17.522 17.523 22 12 22C6.477 22 2 17.522 2 12ZM4 12C4 7.5824 7.5816 4 12 4C16.4184 4 20 7.5824 20 12C20 16.4176 16.4184 20 12 20C7.5816 20 4 16.4176 4 12Z'
        fill={publicaColors.black}
      />
    </svg>
  );
};

export const UndoIconHuge = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M22.2093 22.8239C26.3349 22.8239 30.0564 24.7462 32.4104 27.8344C31.3277 23.2827 27.1651 19.8828 22.2093 19.8828C21.569 19.8828 21.0514 19.357 21.0514 18.7064V16.4441L15.4657 21.3545L21.0514 26.3097V24.0004C21.0514 23.3498 21.569 22.8239 22.2093 22.8239ZM33.5191 34C32.9853 34 32.5198 33.6294 32.3936 33.1024C31.3631 28.8096 27.7377 25.7085 23.3678 25.2391V26.5579C23.3678 27.3884 22.8826 28.1284 22.1022 28.4872C21.2558 28.879 20.2681 28.7378 19.5815 28.1296L13.7156 22.925C13.2605 22.5203 13 21.9474 13 21.3533C13 20.7592 13.2605 20.1863 13.7156 19.7816L19.5815 14.577C20.2681 13.9688 21.2558 13.8276 22.1022 14.2194C22.8826 14.5782 23.3678 15.3182 23.3678 16.1487V17.5816C29.8798 18.1616 35 23.5885 35 30.1766C35 31.1295 34.8796 32.113 34.6434 33.1012C34.5183 33.6294 34.054 34 33.5191 34Z'
        fill={publicaColors.black}
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4 24C4 12.956 12.954 4 24 4C35.046 4 44 12.956 44 24C44 35.044 35.046 44 24 44C12.954 44 4 35.044 4 24ZM8 24C8 15.1648 15.1632 8 24 8C32.8368 8 40 15.1648 40 24C40 32.8352 32.8368 40 24 40C15.1632 40 8 32.8352 8 24Z'
        fill={publicaColors.black}
      />
    </svg>
  );
};
